import * as THREE from "../build/three.module.js";
import { textures, yTileDiff } from './contstants.js';

export function plane(width, height) {
    return function (u, v, target) {
        const x = (u - 0.5) * width;
        const y = (v + 0.5) * height;
        const z = 0;
        target.set(x, y, z);
    };
}

const diff = new THREE.Vector3();

export function satisfyConstraints(p1, p2, distance, index) {
    diff.subVectors(p2.position, p1.position);
    var currentDist = diff.length();
    if (currentDist === 0) return; // prevents division by 0
    var correction = diff.multiplyScalar(1 - distance / currentDist);
    var correctionHalf = correction.clone().multiplyScalar(0.5);
    if (!p1.pinned || (index % 2 === 1)) {
        p1.position.add(correctionHalf);
        p2.position.sub(correctionHalf);
    } else {
        p2.position.sub(correction);
    }
}

export function loadNextTexture(currentTextureIndex, cloth, clothFunction) {
    let loader = new THREE.TextureLoader();

    function loadTexture(url, repeat) {
        if (!url) {
            return null
        }
        let t = loader.load(url);
        t.anisotropy = 16;
        if (repeat) {
            t.wrapS = t.wrapT = THREE.RepeatWrapping;
            t.repeat.set(repeat, repeat);
            t.encoding = THREE.sRGBEncoding;
        }
        return t;
    }

    let texturesToLoad = textures[currentTextureIndex];
    let clothTexture, clothAlphaTexture, clothNormalTexture, clothRoughnessTexture, clothSpecularTexture;

    clothTexture = loadTexture(texturesToLoad.d, texturesToLoad.repreat);
    clothAlphaTexture = loadTexture(texturesToLoad.a, texturesToLoad.repreat);
    clothNormalTexture = loadTexture(texturesToLoad.n, texturesToLoad.repreat);
    clothRoughnessTexture = loadTexture(texturesToLoad.r, texturesToLoad.repreat);
    clothSpecularTexture = loadTexture(texturesToLoad.s, texturesToLoad.repreat);

    const material = new THREE.MeshStandardMaterial({
        map: clothTexture,
        alphaMap: clothAlphaTexture,
        normalMap: clothNormalTexture,
        roughnessMap: clothRoughnessTexture,
        specularMap: clothSpecularTexture,
        side: THREE.DoubleSide,
        alphaTest: 0.5,
        aoMapIntensity: 2,
        depthWrite: true,
    });


    // cloth geometry

    const geometry = new THREE.ParametricBufferGeometry(clothFunction, cloth.w, cloth.h);

    // cloth mesh

    const object = new THREE.Mesh(geometry, material);
    object.position.set(0, 0, 0);
    object.castShadow = true;
    object.receiveShadow = false;
    object.renderOrder = 3;

    return {material, geometry, object}
}


export function loadTextureByUrls(textureMaps, cloth, clothFunction, encoding = THREE.LinearEncoding) {
    let loader = new THREE.TextureLoader();

    function loadTexture(url, tilesCountX, tilesCountY) {
        if (!url) {
            return null
        }
        let t = loader.load(url);
        t.anisotropy = 16;
        if (tilesCountX && tilesCountY) {
            t.wrapS = t.wrapT = THREE.RepeatWrapping;
            t.repeat.set(-tilesCountX, tilesCountY * yTileDiff);
        }
        t.flipY = false;
        //t.encoding = encoding;
        return t;
    }

    let clothTexture, clothAlphaTexture, clothNormalTexture, clothRoughnessTexture, clothSpecularTexture;
    clothTexture = loadTexture(textureMaps.map, textureMaps.tilesCountX, textureMaps.tilesCountY, THREE.sRGBEncoding);
    clothAlphaTexture = loadTexture(textureMaps.alphaMap, textureMaps.tilesCountX, textureMaps.tilesCountY);
    clothNormalTexture = loadTexture(textureMaps.normalMap, textureMaps.tilesCountX, textureMaps.tilesCountY);
    clothRoughnessTexture = loadTexture(textureMaps.roughnessMap, textureMaps.tilesCountX, textureMaps.tilesCountY);
    clothSpecularTexture = loadTexture(textureMaps.specularMap, textureMaps.tilesCountX, textureMaps.tilesCountY);
    let displacementMap = loadTexture(textureMaps.displacementMap, textureMaps.tilesCountX, textureMaps.tilesCountY);
    // let envMap = loadTexture('/mtl/1/bd_br_mont-blanc_mont-blanc_22-bordeaux_edited_s.png', textureMaps.tilesCountX, textureMaps.tilesCountY);

    const material = new THREE.MeshStandardMaterial({
        map: clothTexture,
        alphaMap: clothAlphaTexture,
        normalMap: clothNormalTexture,
        roughnessMap: clothRoughnessTexture,
        specularMap: clothSpecularTexture,
        displacementMap: displacementMap,
        side: THREE.DoubleSide,
        transparent: true,
        aoMapIntensity: 0,
        depthWrite: true,
    });


    // cloth geometry
    const geometry = new THREE.ParametricBufferGeometry(clothFunction, cloth.w, cloth.h);

    // cloth mesh
    const object = new THREE.Mesh(geometry, material);
    object.position.set(0, 0, 0);
    object.castShadow = true;
    object.receiveShadow = false;
    object.renderOrder = 3;

    return {material, geometry, object}
}
